import React from 'react';
import { cn } from '@/lib/utils';

type IPageBodyProps = {
    children?: any;
    className?: string;
}

export const PageBody = ({ children, className } : IPageBodyProps) => {
	return (
		<div className={cn(
			"space-y-4",
			className
		)}>
			{children}
		</div>
	);
};